<template>
    <div class="stock-summary">
        <div class="wrap">
            <div class="search-header">
                <div class="selsect-month">
                    <span class="change-month last" @click="changeMonth('last')">上一月</span>
                    <el-date-picker v-model="nowMonth" format="yyyy-MM" value-format="yyyy-MM" :picker-options="pickerOptions" type="month" placeholder="选择月">
                    </el-date-picker>
                    <span class="change-month next" @click="changeMonth('next')">下一月</span>
                </div>
            </div>
            <div class="list-wrap">
                <div class="table-header">
                        <table>
                            <tr>
                                <th style="width:6%;">序号</th>
                                <th style="width:14%;">名称</th>
                                <th style="width:6%;">件数</th>
                                <th style="width:10%;">类型</th>
                                <th style="width:12%;">原因</th>
                                <th style="width:20%;">备注</th>
                                <th style="width:20%;">时间</th>
                                <th style="width:12%;">操作人员</th>
                            </tr>
                        </table>
                    </div>
                <div class="list">
                    <div class="table-cont">
                        <table v-if="sumList.length>0" style="table-layout:fixed;">
                            <tr v-for="(item,index) in sumList" :key="index">
                                <td style="width:6%;">{{((nowPage-1) * pageSize + index + 1)}}</td>
                                <td style="width:14%;" ><div class="name">{{item.skuName}}</div></td>
                                <td style="width:6%;">{{item.quantity}}</td>
                                <td style="width:10%;">{{stockType[item.type]}}</td>
                                <td style="width:12%;">{{sourceType[item.source]}}</td>
                                <td style="width:20%;">{{item.notes===""?"暂无备注":item.notes}}</td>
                                <td style="width:20%;">{{item.addTime | dateForGradePage}}</td>
                                <td style="width:12%;">{{item.operatorName}}</td>
                            </tr>
                        </table>
                        <div class="no-data" v-else>暂无记录</div>
                    </div>
                </div>
            </div>
            <div class="sum-total">
                <span class="total-money">总金额：</span><span class="amount">{{totalAmount | toFixedNum}}</span>
                <span class="total-count">总数量：</span><span class="count">{{totalCount}}</span>
            </div>
            <span class="excel" @click="excel">导出excel</span>
            <div class="pagination">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="nowPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="totalElements">
                </el-pagination>
            </div>
            <table id="sum" style="display:none;"></table>
        </div>
    </div>
</template>

<script>
export default {
  name: "stockSummary",
  props:['curStoreId'],
  data() {
    return {
      nowMonth: new Date().Format("yyyy-MM"), //当前日期
      pickerOptions: {
        //时间禁用,今天以后的时间禁用。
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2017,01,01").getTime()
          );
        }
      },
      num:['01','02','03','04','05','06','07','08','09','10','11','12'],//月份string
      curMonth:parseInt((new Date).getMonth()+1),//当前月份
      sumList:[],//汇总列表数据
      pageSize:10,//每页数据大小
      nowPage:0,
      sourceType:{
        PURCHASE_IN:'采购入库',
        ALLOCATION_IN:'调拨入库',
        CHECK_IN:'盘点入库',
        INNER_IN:'吧台到仓库',
        CHECK_OUT:'盘点出库',
        INNER_OUT:'仓库至吧台',
        REFUND_OUT:'退货出库',
        ALLOCATION_OUT:'调拨出库'
      },
      stockType:{
        STOCK_IN: "入库",
        STOCK_OUT: "出库"
      },
      totalElements:0,
      totalAmount:0,//总金额
      totalCount:0//总数量
    };
  },
  watch:{
      nowMonth(val){
          console.log(val)
          let date = new Date(val).Format("yyyy-MM");
          let year = date.split("-")[0];
          let month = date.split("-")[1];
          this.getStockSumList(year,month,0);
          this.getTotalInfo(year,month);
      }
  },
  methods: {
    //   更改当前日期
    changeMonth(changeType) {
      console.log(this.nowMonth);
      this.nowMonth = new Date(this.nowMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
      let year = this.nowMonth.split('-')[0];//选择的年
      let month = this.nowMonth.split('-')[1];//选则的月
      if(changeType === "last"){
        //上月
        if(new Date('2017,01,01').Format("yyyy-MM")==new Date(this.nowMonth).Format("yyyy-MM")) {
            this.$message({
                message: '不能选择2017年以前的时间!',
                customClass: 'error'
            })
            return;
        }
        this.curMonth --;
        if(this.curMonth == 0) {
            year = parseInt(year)-1;
            this.curMonth = 12;
        }
      }else if(changeType === "next"){
        //下月
        if(new Date().Format("yyyy-MM")==new Date(this.nowMonth).Format("yyyy-MM")) {
            this.$message({
                message: '已经是最新一个月了！',
                customClass: 'error'
            })
            return;
        }
        this.curMonth ++;
        if(this.curMonth == 13) {
            year = parseInt(year) + 1;
            this.curMonth = 1;
        }
      }
      this.nowMonth = year+'-'+this.num[parseInt(this.curMonth)-1];
    },
    // 获取列表数据
    getStockSumList(year,month,page){
        this.$http({
            url:"get-stockList",
            method:"GET",
            params:{
                storeId:this.curStoreId,
                year,
                month,
                page,
                size:this.pageSize
            }
        }).then(res=>{
            console.log(res);
            this.totalElements = res.data.totalElements;
            this.sumList = res.data.content;
        })
    },
    // 获取总计信息
    getTotalInfo(year,month){
        this.$http({
            url:"get-Statistics",
            method:"GET",
            params:{
                storeId:this.curStoreId,
                year,
                month
            }
        }).then(res=>{
            console.log(res);
            if(this.totalAmount == null){
                this.totalAmount = 0;
            }else{
                this.totalAmount = res.data.amount;
            }
            if(res.data.count == null){
                this.totalCount = 0;
            }else{
                this.totalCount = res.data.count;
            }
        })
    },
    handleCurrentChange(page){
        console.log(page);
        let date = new Date(this.nowMonth).Format("yyyy-MM");
        let year = date.split("-")[0];
        let month = date.split("-")[1];
        this.getStockSumList(year,month,page-1);
    },
    // 导出Excel
    excel(){
        console.log(this.nowMonth);
        let date = new Date(this.nowMonth).Format("yyyy-MM");
        let year = date.split("-")[0];
        let month = date.split("-")[1];
        let sumData;
        this.$http({
            url:"get-stockList",
            method:"GET",
            params:{
                storeId:this.curStoreId,
                year,
                month,
                page:0,
                size:100000
            }
        }).then(res=>{
            sumData = res.data.content;
            if ( !sumData ) {
                this.$message({
                    message: '无数据可导出',
                    customClass: 'error'
                })
                return;
            }
            let data = sumData;
            let num =0,price=0;
            let html = '<tr>'+  
                    '<td style="font-size:18px">名称</td>'+
                    '<td style="font-size:18px">件数</td>'+
                    '<td style="font-size:18px">类型</td>'+ 
                    '<td style="font-size:18px">原因</td>'+
                    '<td style="font-size:18px">备注</td>'+
                    '<td style="font-size:18px">时间</td>'+
                    '<td style="font-size:18px">操作人员</td>'+
                '</tr>'
            for(var i=0;i<data.length;i++){
                if ( !data[i].skuName ) {
                    continue;
                }
                let date = new Date(data[i].addTime);
                let year = date.getFullYear();
                let month = (date.getMonth() + 1)>9?(date.getMonth() + 1):"0"+(date.getMonth() + 1);
                let day = date.getDate()>9?date.getDate():"0"+date.getDate();
                let hours = date.getHours();
                let minutes = date.getMinutes()>9?date.getMinutes():"0"+date.getMinutes();
                let seconds = date.getSeconds()>9?date.getSeconds():"0"+date.getSeconds();
                let addTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                html  +='<tr>'+
                    '<td>'+data[i].skuName+'</td>'+
                    '<td>'+data[i].quantity+'</td>'+ 
                    '<td>'+this.stockType[data[i].type]+'</td>'+ 
                    '<td>'+this.sourceType[data[i].source]+'</td>'+ 
                    '<td>'+data[i].notes+'</td>'+ 
                    '<td>'+addTime+'</td>'+ 
                    '<td>'+data[i].operatorName+'</td>'+ 
                '</tr>'
            }
            html+='<tr style="font-size:18px;color:red;">'+
                '<td></td>'+
                '<td></td>'+
                '<td></td>'+
                '<td>总金额：'+Number(this.totalAmount).toFixed(2)+'</td>'+
                '<td></td>'+
                '<td>总数量：'+this.totalCount+'</td>'+
                '<td></td>'+
            '</tr>'
            document.getElementById('sum').innerHTML = html;
            window.method5(sum);
        })
    }
  },
  activated() {
    let year = this.nowMonth.split("-")[0];
    let month = this.nowMonth.split("-")[1];
    this.getStockSumList(year,month,0);
    this.getTotalInfo(year,month);
  }
};
</script>

<style lang="scss">
@import "./../../../../../static/css/common.scss";
@import "./../../../tableTemplate/tableTem.scss";
@import "./../../../tableTemplate/el-dialog.scss";
@import "./stockSummary.scss";
</style>



// WEBPACK FOOTER //
// stockSummary.vue?2092055f